// NPM
/* Load npm scripts here */

// VENDOR
/* Load vendor modules here */

// BUNDLES
/* Load bundles here */
import defaultBundle from 'bundles/default.bundle';

// HELPERS
/* Load helpers here */
import { CustomerMobileMenu } from 'helpers/customer-service/mobile-menu/mobileMenu';

// COMPONENTS
/* Load components here */

// PAGE
/* load page specific scripts */
import { ContactForm } from 'components/contact-form/contact-form';

defaultBundle();
ContactForm.init();
CustomerMobileMenu.init();
